var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{class:_vm.activeLocation,on:{"click":function($event){return _vm.emitLocation(_vm.location.id)}}},[_vm._v(" "+_vm._s(_vm.location.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }